import Vue from 'vue'

/**
 * 保存导出记录
 * @param data
 * @returns {*}
 */
export function saveExportRecord(data) {
  return Vue.axios({
    url: '/api/export_record/save',
    method: 'post',
    data
  })
}

/**
 * @param api
 * @param params
 * @returns {AxiosPromise}
 */
export async function getExportPage(api, params) {
  if (typeof api === 'function') {
    return await api(params)
  }
  return Vue.axios({
    url: `${api}`,
    method: 'get',
    params
  })
}
